import { Icon } from '@iconify/react';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
// import settingsFill from '@iconify/icons-eva/settings-fill';
// import peopleFill from '@iconify/icons-eva/people-fill';
import brushFill from '@iconify/icons-eva/brush-fill';
import plusFill from '@iconify/icons-eva/plus-fill';
import listFill from '@iconify/icons-eva/list-fill';
// import codeFill from '@iconify/icons-eva/code-fill';
// import fileTextFill from '@iconify/icons-eva/file-text-fill';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import DiscountIcon from '@mui/icons-material/Discount';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import calendarFill from '@iconify/icons-eva/calendar-fill';
// import archiveFill from '@iconify/icons-eva/archive-fill';

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

export const sidebarEventManagement = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: getIcon(pieChart2Fill),
    queryEvent: true,
    children: [
      {
        title: 'Sales',
        path: '/dashboard/sales',
        queryEvent: true
      },
      {
        title: 'Entries',
        path: '/dashboard/entries',
        queryEvent: true
      }
    ]
  },
  {
    title: 'Details / Edit',
    path: '/event/edit',
    icon: getIcon(calendarFill),
    queryEvent: true
  },
  {
    title: 'Tickets',
    path: '/ticket/list',
    icon: <ConfirmationNumberIcon />,
    queryEvent: true
  },
  {
    title: 'Vouchers',
    path: '/voucher/list',
    icon: <DiscountIcon />,
    queryEvent: true
  },
  {
    title: 'QRCode Scanner',
    path: '/qrcode/scanner',
    icon: <QrCodeScannerIcon />,
    queryEvent: true
  }
  // {
  //   title: 'Inventory',
  //   path: '/profile',
  //   icon: getIcon(archiveFill),
  //   queryEvent: true
  // }
];

export const sidebarGeneralEventsSettings = [
  {
    title: 'My Events',
    path: '/event/list',
    icon: getIcon(listFill)
  },
  {
    title: 'New Event',
    path: '/event/create',
    icon: getIcon(plusFill)
  }
];

export const sidebarEventSettings = [
  {
    title: 'Theme',
    path: '/theme',
    icon: getIcon(brushFill)
  }
  // {
  //   title: 'Metatags',
  //   path: '/metatags',
  //   icon: getIcon(codeFill)
  // },
  // {
  //   title: 'Legal Content',
  //   path: '/legal-content',
  //   icon: getIcon(fileTextFill)
  // }
];

export const sidebarProducerSettings = [
  // {
  //   title: 'General',
  //   path: '/settings/general',
  //   icon: getIcon(settingsFill)
  // },
  // {
  //   title: 'Users',
  //   path: '/users',
  //   icon: getIcon(peopleFill)
  // },
  // {
  //   title: 'Theme',
  //   path: '/settings/theme',
  //   icon: getIcon(brushFill)
  // }
  // {
  //   title: 'Metatags',
  //   path: '/metatags',
  //   icon: getIcon(codeFill)
  // },
  // {
  //   title: 'Legal Content',
  //   path: '/legal-content',
  //   icon: getIcon(fileTextFill)
  // }
];
